import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Col, Container, Row } from "react-bootstrap"
import { debounce } from "../functions"

const Secondary = ({ menu }) => {
  const breakpoint = 801

  const [screen, setMobile] = useState({
    isMobile: typeof window !== `undefined` && window.innerWidth < breakpoint,
  })

  const [isClient, setClient] = useState(false)

  useEffect(() => {
    setClient(true)

    const debouncedHandleResize = debounce(function handleResize() {
      setMobile({
        isMobile:
          typeof window !== `undefined` && window.innerWidth < breakpoint,
      })
    }, 200)

    if (typeof window !== `undefined`) {
      window.addEventListener("resize", debouncedHandleResize)
    }
  }, [])

  const toggleMenu = (e) => {

    const getAllBtn = document.querySelectorAll(".js-subMenuMob")
    if (getAllBtn) {
      getAllBtn.forEach(item => item.classList.remove('show'));
    }
    const currentElem = e.currentTarget
    currentElem.classList.add("show")

  }
  const closeMenu = (e) => {
    e.currentTarget.previousElementSibling.classList.remove('show')
  }
  const closeMenuMob = () => {
    const mobNavBtn = document.querySelector(".btnNavMob")
    mobNavBtn.click()
  }

  return (
    <>
      <Link to={menu.link.url}>{menu.title}</Link>
      {isClient && screen.isMobile ? (
        <>
          <button
            onClick={toggleMenu}
            aria-label="Sub Menu Mob"
            className="js-subMenuMob"
            id={"itemMob-" + menu.drupal_id}
          ></button>
          <button
            onClick={closeMenu}
            aria-label="Sub Menu Mob"
            className="js-close-subMenuMob"
            id={"itemMob-" + menu.drupal_id}
          ></button>
        </>
      ) : (
        <></>
      )}

      <div className="subMenu">
        <Container>
          {/*<Row>*/}
          {/*  <Col xs={12}>*/}
          {/*    <h2>{menu.title}</h2>*/}
          {/*  </Col>*/}
          {/*</Row>*/}
          <Row>
            <Col md={menu.childNodes.length === 3 ? 12 : 8} xs={12}>
              <ul className="second-level">
                {menu.childNodes.map(secondary => {
                  return (
                    <li key={secondary.drupal_id}>
                      {
                        menu.drupal_id === "01bc5b5e-55ad-46dd-a10b-edc9e05b9bd3" ? (
                          <Link onClick={closeMenuMob} to={menu.link.url + secondary.link.url}>
                            <span>{secondary.title}</span>
                          </Link>
                        ) : (
                          <Link to={secondary.link.url}>
                            {secondary.relationships.image && (
                              <figure>
                                <GatsbyImage
                                  image={getImage(
                                    secondary.relationships.image.relationships
                                      .field_image.gatsbyImage
                                  )}
                                  alt={""}
                                />
                              </figure>
                            )}
                            <span>{secondary.title}</span>
                          </Link>
                        )
                      }
                    </li>
                  )
                })}
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default Secondary
